import React, { Component } from 'react';
import imagemQRCode from '../assets/images/certificado_qrcode.png';
import DateFormat from '../common/dateFormat/DateFormat';

class CertificadoModeloFolha extends Component {

	replaceTag(texto) {		
		return (texto || '').replace('<aluno>', this.props.registro.nome_aluno || '<aluno>')
			.replace('<instrutor>', this.props.registro.nome_instrutor || '<instrutor>')
			.replace('<nome_cliente>', this.props.registro.nome_cliente || '<nome_cliente>')
			.replace('<curso>', this.props.registro.curso || '<curso>')
			.replace('<carga_horaria>', this.props.registro.carga_horaria || '<carga_horaria>')
			.replace('<data_emissao>', DateFormat.formatarDataSqlParaTela(this.props.registro.data_emissao) || '<data_emissao>')
			.replace('<data_inicio>', DateFormat.formatarDataSqlParaTela(this.props.registro.data_inicio) || '<data_inicio>')
			.replace('<data_fim>', DateFormat.formatarDataSqlParaTela(this.props.registro.data_fim) || '<data_fim>')
	}

	carregarAssinatura(tag) {
		if (tag == '<aluno>') {
			return this.props.registro.assinatura_aluno;
		} else if (tag == '<instrutor>') {
			return this.props.registro.assinatura_instrutor;
		} else {
			return null;
		}
	}

	existeModulo(modulo) {
		if ((this.props.registro.modulos || []).length) {
			return (this.props.registro.modulos || []).includes(modulo);
		}
		return true;
	}

    render() {

		const registro = this.props.registro;

		return (
				<div style={{ display: 'flex', justifyContent: 'center' }}>
					<div
						style={{ 
							width: 1020,
							height: 720,
							margin: '0 auto',
							paddingTop: 130,
							paddingLeft: 50,
							paddingRight: 50,
							paddingBottom: 55,
							position: 'relative',
							backgroundImage: `url("${registro.imagem_template}")`,
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							backgroundRepeat: 'no-repeat'
						}}>
							<div 
								style={{
									position: 'relative',
									zIndex: 10,
									width: '100%',
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',
									color: registro.cor_fonte || '#000000'
								}}>

								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										justifyContent: 'center',
										alignItems: 'center',
										height: 60,
										textAlign: 'center',
										fontSize: 26,
										fontWeight: 'bold',
										 color: registro.cor_fonte_titulo || '#000000'
									}}>
									{this.replaceTag(registro.titulo)}
								</div>

								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										justifyContent: 'center',
										alignItems: 'center',
										height: 60,
										textAlign: 'center',
										fontSize: 16
									}}>
									{this.replaceTag(registro.texto1)}
								</div>

								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										justifyContent: 'center',
										alignItems: 'center',
										height: 60,
										textAlign: 'center',
										fontSize: 24
									}}>
								<div>{this.replaceTag('<aluno>')}</div>
								<hr
									style={{
										border: 0,
										height: 4,
										background: registro.cor_linha || '#000000',
										margin: '2px 0',
										borderRadius: 4,
										width: 750
									}} />
								</div>

								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										justifyContent: 'center',
										alignItems: 'start',
										height: 70,
										width: '100%',
										textAlign: 'center',
										fontSize: 16,
										paddingLeft: 80,
										paddingRight: 80
									}}>
									{this.replaceTag(registro.texto2)}
								</div>

								<div style={{ height: 70, textAlign: 'center' }}>
									<img src={registro.QRCode} style={{ height: 60 }} />
								</div>

								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										justifyContent: 'center',
										alignItems: 'end',
										height: 70,
										marginBottom: 8
									}}>
									{registro.assinatura1 &&
									<div style={{ marginLeft: 100, marginRight: 100, textAlign: 'center' }}>
										<div style={{ height: 30, textAlign: 'center' }}>
											<img 
												src={registro.imagem_assinatura1 || this.carregarAssinatura(registro.assinatura1)} 
												style={{ height: '100%' }} />
										</div>
										<hr
											style={{
												border: 0,
												height: 1,
												background: registro.cor_linha || '#000000',
												margin: '2px 0',
												borderRadius: 4,
												width: 300
											}} />
										<div>{this.replaceTag(registro.assinatura1)}</div>
									</div>}
									{registro.assinatura2 &&
									<div style={{ marginLeft: 100, marginRight: 100, textAlign: 'center' }}>
										<div style={{ height: 30, textAlign: 'center' }}>
											<img 
												src={registro.imagem_assinatura2 || this.carregarAssinatura(registro.assinatura2)} 
												style={{ height: '100%' }} />
										</div>
										<hr
											style={{
												border: 0,
												height: 1,
												background: registro.cor_linha || '#000000',
												margin: '2px 0',
												borderRadius: 4,
												width: 300
											}} />
										<div>{this.replaceTag(registro.assinatura2)}</div>
									</div>}
								</div>

								<div style={{ height: 25, textAlign: 'center', fontSize: 12 }}>
									<p style={{ fontWeight: 'bold' }}>{this.replaceTag(registro.texto3)}</p>
								</div>
								<div style={{ display: 'flex', flex: 4, flexDirection: 'row', height: 100, justifyContent: 'center', textAlign: 'center', fontSize: 10 }}>
									{this.existeModulo(registro.nome_modulo1) &&
									<div style={{ flex: 1, marginLeft: 4, marginRight: 4 }}>
										<div style={{ fontWeight: 'bold' }}>{registro.nome_modulo1}</div>
										{this.replaceTag(registro.descricao_modulo1 || '').split('\n').map((linha, i) => (
											<div key={i}>{linha}</div>
										))}
									</div>}
									{this.existeModulo(registro.nome_modulo2) &&
									<div style={{ flex: 1, marginLeft: 4, marginRight: 4 }}>
										<div style={{ fontWeight: 'bold' }}>{registro.nome_modulo2}</div>
										{this.replaceTag(registro.descricao_modulo2 || '').split('\n').map((linha, i) => (
											<div key={i}>{linha}</div>
										))}
									</div>}
									{this.existeModulo(registro.nome_modulo3) &&
									<div style={{ flex: 1, marginLeft: 4, marginRight: 4 }}>
										<div style={{ fontWeight: 'bold' }}>{registro.nome_modulo3}</div>
										{this.replaceTag(registro.descricao_modulo3 || '').split('\n').map((linha, i) => (
											<div key={i}>{linha}</div>
										))}
									</div>}
									{this.existeModulo(registro.nome_modulo4) &&
									<div style={{ flex: 1, marginLeft: 4, marginRight: 4 }}>
										<div style={{ fontWeight: 'bold' }}>{registro.nome_modulo4}</div>
										{this.replaceTag(registro.descricao_modulo4 || '').split('\n').map((linha, i) => (
											<div key={i}>{linha}</div>
										))}
									</div>}
								</div>
							</div>
					</div>
				</div>
		);
    }     

}

export default CertificadoModeloFolha;
